import type { AboutCareersContent } from '../types/AboutCareersContent';

export function createAboutCareersContentPlaceholder(): AboutCareersContent {
    return {
        pageTitle: { kind: 'plainText', key: '', content: '' },
        pageSubtitle: { kind: 'plainMultilineText', key: '', content: '' },
        pageTitleBackgroundImage: { kind: 'image', key: '', imageUrl: '' },
        mainTab: {
            title: { kind: 'plainText', key: '', content: '' },
            mainText: { kind: 'richText', key: '', content: '', sanitizedContent: '' },
            mainImage: { kind: 'image', key: '', imageUrl: '' },
            searchJobsLink: { kind: 'internalLink', key: '', linkText: '', linkRoute: '' },
        },
    };
}
